import z from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { RechargeBillingState } from "__generated__/enums";

export const rechargeBillingStatusSchema = z.object({
	billingState: ZodSchema.requiredField(z.enum(RechargeBillingState)),
});

export type RechargeBillingStatusSchemaInput = z.input<typeof rechargeBillingStatusSchema>;
export type RechargeBillingStatusSchemaOutput = z.output<typeof rechargeBillingStatusSchema>;
